import './TotalTripCostDateHeader.scss';

import { useSelector } from 'react-redux';

import { useLocalisation } from '../../../../services/contextAdaptor/LocalisationContext';
import {
  getSelectedInboundDate,
  getSelectedOutboundDate,
} from '../../selectors';

import type { State } from '../../selectors/types';

const TotalTripCostDateHeader = () => {
  const { formatDateFullAbbr } = useLocalisation();

  const destinationName = useSelector(
    (state: State) => state.initialSearchParams.destinationName,
  );
  const inboundDate = useSelector((state: State) =>
    getSelectedInboundDate(state),
  );
  const outboundDate = useSelector((state: State) =>
    getSelectedOutboundDate(state),
  );

  const showDates = () => {
    if (!inboundDate) {
      return formatDateFullAbbr(outboundDate)
        .replaceAll(',', '')
        .replaceAll('.', '');
    }

    return `${formatDateFullAbbr(outboundDate)} - ${formatDateFullAbbr(inboundDate)}`
      .replaceAll(',', '')
      .replaceAll('.', '');
  };

  return (
    <div className="total-trip-cost-date-header-summary-date-container">
      <div>
        <span className="total-trip-cost-date-header-summary-city-name">
          {destinationName}
        </span>

        <div className="total-trip-cost-date-header-summary-booking-info">
          <span>{showDates()}</span>
        </div>
      </div>
    </div>
  );
};

export { TotalTripCostDateHeader };
